module.exports = __webpack_public_path__ + "static/media/image_2.d5e34b08.jpg";